import { gql } from '@apollo/client'
import { useSafeRunMutation } from 'utils/mutations'

const mutation = gql`
  mutation doctorInsuranceUpdate(
    $npi: NPI!
    $add_uids: [String]
    $remove_uids: [String]
    $location_uuid: String!
    $employee_id: ID
  ) {
    doctorInsuranceUpdate(
      npi: $npi
      add_uids: $add_uids
      remove_uids: $remove_uids
      location_uuid: $location_uuid
      employee_id: $employee_id
    ) {
      id
    }
  }
`

export default function useProviderInsuranceUpdate() {
  const { onMutate: onProviderInsuranceUpdate, loading } = useSafeRunMutation({
    mutation,
    responsePath: 'doctorInsuranceUpdate',
    successMessage: 'Provider insurance updated'
  })

  return { onProviderInsuranceUpdate, loading }
}
